import { useAppModal } from "@/components/controls"
import { ScheduleActivity } from "../ScheduleActivity"
import type { TScheduleProps } from "../types"

export function useScheduleActivity({ title, activityId, activityType }: TScheduleProps) {
  return useAppModal({
    title,
    size: "xl",
    closeOnClickOutside: false,
    children: <ScheduleActivity activityId={activityId} activityType={activityType} />,
  })
}
